module.exports = __webpack_public_path__ + "img/image006.086f312f.png";